import {apiInstance} from "../api";

const route = '/flat-edits';

// «Журнал правок»: ECI old's «Просмотреть изменения» of a flat
export class FlatEditsService {
  // { total, items: [{ id, at, user, field, source, oldValue, value }], statuses: [{ date, status }] }, 500 at a time
  static fetch(apartmentId, offset = 0) {
    return apiInstance.get(`${route}/${apartmentId}`, {params: {offset}});
  }
}
